import createSimulation from './createSimulation'
import simulateRules from './simulateRules'
import getSimulacion from './getSimulacion'
import getStatusMotor from './getStatusMotor'

export const createSimulationPromise = createSimulation
export const simulateRulesPromise = simulateRules
export const getSimulacionPromise = getSimulacion
export const getStatusMotorPromise = getStatusMotor
